<template>
  <MasterLayout>
    <div class="new-staff w-98">
      <div class="row">
        <div class="col-md-5">
          <div class="add_new_bank_account_header">
            <p>
              {{ mode === "create" ? "Add" : "Edit" }}
              {{ $t("text.bServices.transaction") }}
            </p>
          </div>

          <div class="cover">
            <div class="personal">
              <div class="row">
                <div class="mt-4 input__group__block col-md-6">
                  <label class="required">
                    <span class="mylabel">
                      {{ $t("text.bServices.unitPrice") }}
                    </span>
                  </label>

                  <div class="price_change_input_wrapper">
                    <input
                      type="number"
                      :placeholder="$t('text.bServices.unitPrice')"
                      class="border-0"
                      v-model="serviceTransaction.unitPrice"
                    />
                  </div>
                </div>

                <div class="mt-4 input__group__block col-md-6">
                  <label class="required">
                    <span class="mylabel">
                      {{ $t("text.bServices.service") }}
                    </span>
                  </label>

                  <div class="e-form price_change_input_wrapper">
                    <model-select
                      :options="services"
                      v-model="service"
                      :placeholder="$t('text.bServices.selectService')"
                    >
                    </model-select>
                  </div>
                </div>
                <div class="mt-4 input__group__block col-md-6">
                  <label class="required">
                    <span class="mylabel">
                      {{ $t("text.bServices.serviceDescription") }}
                    </span>
                  </label>

                  <div class="price_change_input_wrapper">
                    <input
                      type="text"
                      :placeholder="$t('text.bServices.serviceDescription')"
                      class="border-0"
                      v-model="serviceTransaction.description"
                    />
                  </div>
                </div>
                <div class="col-md-6"></div>
              </div>
            </div>

            <div class="pb-4 mt-4 text-center" v-if="mode === 'create'">
              <button
                class="ep-btn ep-btn-theme"
                @click="addTransaction($event)"
              >
                {{ $t("text.bServices.addTransaction") }}
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-7">
          <div v-if="formData.items.length">
            <b-table striped hover :items="formData.items" :fields="fields">
              <template #cell(action)="data">
                <i
                  class="cursor-pointer fa fa-minus-circle red-color fa-icon"
                  v-b-tooltip.hover
                  :title="$t('text.bServices.removeItem')"
                  aria-hidden="true"
                  @click="removeTransaction(data.index)"
                ></i>
              </template>
              <template #cell(price)="data">
                <input
                  type="number"
                  class="form-control"
                  v-model="formData.items[data.index].price"
                />
              </template>
              <template #cell(description)="data">
                <input
                  type="text"
                  class="form-control"
                  v-model="formData.items[data.index].description"
                />
              </template>
              <template #cell(serviceName)="data">
                <input
                  type="text"
                  class="form-control"
                  v-model="formData.items[data.index].serviceName"
                />
              </template>
            </b-table>
            <div class="mt-3 text-right">
              <div class="display-flex align-items-center justify-content-end">
                <h6 class="mr-2 font-bold">
                  {{ $t("text.bServices.totalPrice") }}:
                </h6>
                <h6>
                  {{ branch ? branch.currencyCode : "" }}
                  {{ convertThousand(totalPrice) }}
                </h6>
              </div>
            </div>
            <div class="mt-3 row">
              <div class="col-md-8"></div>
              <div class="text-right col-md-4">
                <div>
                  <label>{{ $t("text.bServices.enterCustomerName") }}</label>
                  <input
                    type="text"
                    :placeholder="$t('text.bServices.customerName')"
                    class="form-control"
                    v-model="formData.customer"
                  />
                </div>
              </div>
            </div>
            <div class="mt-3 row">
              <div class="col-md-8"></div>
              <div class="text-right col-md-4">
                <div>
                  <vue-ctk-date-time-picker
                    v-model="formData.startDate"
                    :max-date="formData.maxDate"
                    :onlyDate="true"
                    :autoClose="true"
                    :locale="this.$root.$i18n.locale"
                    :color="$store.getters.getDatePickerColor"
                    format="YYYY-MM-DDTHH:mm:ss"
                    formatted="DD/MM/YYYY"
                    :label="$t('text.calendar.selectDate')"
                  />
                </div>
              </div>
            </div>

            <div class="mt-3 text-right">
              <button
                class="btn btn-warning"
                :disabled="isButtonDisabled ? true : false"
                @click="
                  mode === 'create'
                    ? createTransactions($event)
                    : updateTransaction($event)
                "
              >
                {{ $t("text.bServices.submitTransaction") }}
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="35px"
                  class="ml-3 loader"
                />
              </button>
            </div>
          </div>
          <div class="empty-info-wrapper new-row" v-else>
            <img src="@/assets/img/box-grayed.png" width="50" />
            <p class="mt-5 light-grey-text">
              {{ $t("text.bServices.noTransactAdded") }}
            </p>
            <small class="light-grey-text">{{
              $t("text.bServices.transactWillAdd")
            }}</small>
            <div class="mt-5"></div>
          </div>
        </div>
      </div>
    </div>
  </MasterLayout>
</template>

<script>
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import configObject from "@/config";
import backgroundUrl from "@/assets/img/retain.jpg";
import VueTagsInput from "@johmun/vue-tags-input";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import "vue-search-select/dist/VueSearchSelect.css";
import { ModelSelect } from "vue-search-select";

import JQuery from "jquery";
// import indexVue from '../variance_report/index.vue';
let $ = JQuery;

export default {
  name: "AddStaff",
  title: "Add company service transaction",
  components: {
    MasterLayout,
    VueTagsInput,
    PulseLoader,
    ModelSelect,
  },
  data() {
    return {
      catId: null,
      isButtonDisabled: false,
      showLoader: true,
      name: null,
      description: null,
      serviceTransaction: {
        quantitySupplied: null,
        unitPrice: null,
        description: null,
      },
      branches: [],
      branch: null,
      services: [],
      service: null,
      mode: "create",
      company: null,
      applyDiscount: false,
      items: [],
      formData: {
        items: this.$store.getters.getBanchTransactions,
        customer: null,
        maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
        startDate: this.$moment().format("YYYY-MM-DDTHH:mm:ss"),
      },
      servicesIds: this.$store.getters.getBranchServiceIds,
      fields: [
        { key: "price", label: `Price`, class: "text-center" },
        { key: "description", label: "Description", class: "text-center" },
        { key: "serviceName", label: "Service", class: "text-center" },
        { key: "action", label: "Action", class: "text-center" },
      ],
    };
  },
  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          this.getServices();
        }
      }
    },
  },
  computed: {
    totalPrice: {
      get() {
        if (this.formData.items.length) {
          return this.formData.items.reduce((acc, cur) => {
            return (acc += Number(cur.price));
          }, 0);
        } else {
          return 0;
        }
      },
      set() {},
    },
  },
  created() {
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Add services transactions :: ${branch.name} Retail Outlet`;
    });
  },
  mounted() {
    if (this.$route.query.serviceId && this.$route.query.serviceName) {
      this.serviceTransaction.description = this.$route.query.description;
      this.service = this.$route.query.serviceId;
      // this.formData.items.push({
      //     price: 0,
      //     description: this.$route.query.description,
      //     service: this.$route.query.serviceId,
      //     serviceName: this.$route.query.serviceName
      // })
      this.$store.commit("setBanchTransactions", [...this.formData.items]);
      this.$store.commit("setBranchServiceIds", [
        ...this.$store.getters.getBranchServiceIds,
        this.$route.query.serviceId,
      ]);
    }
    if (this.$route.query.transactionId) {
      this.mode = "edit";
      const data = JSON.parse(this.$route.query.data);
      this.formData.startDate = data.date;
      this.formData.customer = data.customer;
      this.formData.items.push({
        serviceName: data.companyService,
        price: data.price,
        service: data.companyServiceId,
        description: data.serviceDescription,
      });
    }
  },
  beforeDestroy() {},
  methods: {
    removeTransaction(index) {
      this.formData.items.splice(index, 1);
      this.servicesIds.splice(index, 1);
      this.$store.commit("setBanchTransactions", this.formData.items);
      this.$store.commit("setBranchServiceIds", this.servicesIds);
    },
    getServices() {
      this.showLoader = true;

      this.axios
        .get(
          `${configObject.apiBaseUrl}/Service/CompanyServices/${
            this.branch ? this.branch.companyId : this.$route.query.companyId
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.services = response.data;
          this.showLoader = false;
          response.data.forEach((el, i) => {
            el.text = el.name;
            el.value = el.id;
          });
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },

    addTransaction($event) {
      $event.preventDefault();
      if (!this.serviceTransaction.unitPrice) {
        this.$toast.open({
          message: this.$t("text.bServices.unitPriceReq"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.service) {
        this.$toast.open({
          message: this.$t("text.bServices.kindlySelectService"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.serviceTransaction.description) {
        this.$toast.open({
          message: this.$t("text.bServices.serviceDescReq"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      const service = this.services.filter(
        (service) => service.id === this.service
      )[0];
      this.servicesIds.push(service.id);
      this.formData.items.push({
        price: Number(this.serviceTransaction.unitPrice),
        service: service.id,
        serviceName: service.name,
        description: this.serviceTransaction.description,
      });
      this.serviceTransaction.unitPrice = null;
      this.$store.commit("setBanchTransactions", this.formData.items);
      this.$store.commit("setBranchServiceIds", this.servicesIds);
    },
    createTransactions($event) {
      $event.preventDefault();

      const items = this.formData.items.map((item, index) => {
        const companyServiceId = this.servicesIds[index];
        return {
          companyServiceId: companyServiceId,
          price: parseFloat(item.price),
        };
      });

      let payload = {
        services: items,
        branchId: this.branch.id,
        customer: this.formData.customer,
        date: this.formData.startDate,
      };

      if (!this.formData.customer) {
        this.$toast.open({
          message: this.$t("text.bServices.customerNameReq"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      this.isButtonDisabled = true;
      $(".loader").show();

      this.axios
        .post(
          `${configObject.apiBaseUrl}/Service/Transactions/Add`,
          payload,
          configObject.authConfig()
        )
        .then((res) => {
          this.$store.commit("setBanchTransactions", []);
          this.$store.commit("setBranchServiceIds", []);
          this.$toast.open({
            message: this.$t("text.bServices.nonwetProSupplyCreated"),
            type: "success",
            duration: 5000,
          });
          this.$router.push({
            name: "TransactionServices",
            query: { ...this.$route.query },
          });
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    updateTransaction($event) {
      $event.preventDefault();
      if (!this.branch) {
        this.$toast.open({
          message: this.$t("text.bServices.plsSelectBranch"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      let payload = {
        companyServiceId: this.formData.items[0].service,
        price: this.formData.items[0].price,
        customer: this.formData.customer,
        date: this.formData.startDate,
      };

      console.log(payload);
      // return

      this.isButtonDisabled = true;
      $(".loader").show();

      this.axios
        .put(
          `${configObject.apiBaseUrl}/Service/Transactions/Edit/${this.$route.query.transactionId}`,
          payload,
          configObject.authConfig()
        )
        .then((res) => {
          window.localStorage.setItem(
            "branchServiceTransactions",
            JSON.stringify([])
          );
          window.localStorage.setItem("branchServiceIds", JSON.stringify([]));
          this.$toast.open({
            message: this.$t("text.bServices.nonwetProSupplyCreated"),
            type: "success",
            duration: 5000,
          });
          this.$router.push({
            name: "TransactionServices",
            query: { ...this.$route.query },
          });
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
